;(() => {
	const init = (sectionRoot) => {
		let sectionStats;

		if (document.currentScript) {
			sectionStats = document.currentScript.parentElement;
		} else {
			sectionStats = sectionRoot;
		}

		if (!sectionStats || !sectionStats.classList.contains('section-stats')) {
			return;
		}

		const prefersReducedMotion = window.matchMedia(
			'(prefers-reduced-motion: reduce)'
		).matches;

		const getNumberLengthAfterComma = (x, symbol) =>
			x.toString().includes(symbol)
				? x.toString().split(symbol).pop().length
				: 0;

		const numberElems = sectionStats.querySelectorAll('.stats__number');
		if (!numberElems.length) return;

		const regex = /[0-9]*[.,\s]?[0-9]*[.,\s]?[0-9]*[.,\s]?[0-9]+/g;

		const getNumbers = () => {
			const nums = [];
			numberElems.forEach((el) => {
				const content = el.getAttribute('data-content') || '';
				const matches = content.trim().match(regex);
				nums.push(matches ? matches.map((m) => m.trim()) : null);
			});
			return nums.flat(1).filter(Boolean);
		};

		const initNumbers = () => {
			numberElems.forEach((el) => {
				const content = el.getAttribute('data-content') || '';
				el.innerHTML = content.replace(regex, '<span class="js-num">$&</span>');
			});
		};

		const numbers = getNumbers();
		const od = [];

		const initAnimation = () => {
			sectionStats.querySelectorAll('.js-num').forEach((num, i) => {
				const odometerNumber = numbers[i];
				if (!odometerNumber || typeof Odometer === 'undefined') return;

				let iterator = 0;
				let digitsLength = '';
				let format = 'd';

				if (
					odometerNumber.toString().indexOf('.') !== -1 &&
					(odometerNumber.toString().indexOf('.') <
						odometerNumber.toString().indexOf(',') ||
						odometerNumber.toString().indexOf(',') === -1)
				) {
					iterator = getNumberLengthAfterComma(odometerNumber, '.');
					if (iterator > 2) {
						if (odometerNumber.toString().includes(',')) {
							iterator = getNumberLengthAfterComma(odometerNumber, ',');
							format = '(.ddd),';
						} else {
							iterator = 0;
							format = '(.ddd),dd';
						}
					} else {
						format = '(ddd).';
					}
				}

				if (
					odometerNumber.toString().indexOf(',') !== -1 &&
					(odometerNumber.toString().indexOf(',') <
						odometerNumber.toString().indexOf('.') ||
						odometerNumber.toString().indexOf('.') === -1)
				) {
					if (odometerNumber.toString().includes('.')) {
						iterator = getNumberLengthAfterComma(odometerNumber, '.');
						format = '(,ddd).';
					} else {
						format = '(,ddd)';
					}
				}

				if (odometerNumber.toString().indexOf(' ') !== -1) {
					format = '( ddd),dd';
				}

				for (let j = 0; j < iterator; j++) {
					digitsLength += 'd';
				}

				format = format + digitsLength;

				od[i] = new Odometer({
					el: num,
					format: format,
					theme: 'default',
					value: odometerNumber.replace(/[0-9]+/, '0'),
				});
			});
		};

		const showFinalValues = () => {
			sectionStats.querySelectorAll('.js-num').forEach((num, i) => {
				if (!numbers[i]) return;
				if (od[i]) {
					od[i].update(numbers[i].replaceAll(' ', ''));
				} else {
					num.textContent = numbers[i];
				}
			});
		};

		const initSection = () => {
			initNumbers();

			if (prefersReducedMotion || typeof Odometer === 'undefined') {
				showFinalValues();
				return;
			}

			initAnimation();

			const row = sectionStats.querySelector('.stats__row');
			if (!row) return;

			const sectionObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					entry.target.querySelectorAll('.js-num').forEach((num, i) => {
						if (!od[i] || !numbers[i]) return;
						if (entry.isIntersecting) {
							od[i].update(numbers[i].replaceAll(' ', ''));
						} else {
							od[i].update(0);
						}
					});
				});
			});

			sectionObserver.observe(row);
		};

		initSection();
	};

	init();

	document.addEventListener('shopify:section:load', (event) => {
		init(event.target);
	});
})();
